'use strict';

import {
    Component,
    ElementRef,
    Inject,
    Input,
    OnChanges,
    OnInit
} from "@angular/core";

const ferrous:{[frame: string]: any} = require('ferrous');

@Component({
    selector: 'icon',
    template: ''
})

export class iconComponent implements OnInit, OnChanges {
    el: any
    @Input() symbol: string
    @Input() secondarySymbol: string
    @Input() frame: string
    @Input() attrs: any

    constructor(@Inject(ElementRef) elementRef: ElementRef) {
        this.el = elementRef.nativeElement;
    }

    ngOnInit() {
        this.frame = this.frame || 'none';
        this.attrs = this.attrs ? this.attrs : {};
        this.el.innerHTML = generateMarkup(this.frame, this.symbol, this.secondarySymbol, this.attrs);
    }

    ngOnChanges() {
        let attrs = this.attrs || {};
        this.el.innerHTML = generateMarkup(this.frame, this.symbol, this.secondarySymbol, attrs);
    }
}

function generateMarkup(
    frame: string,
    symbol: string,
    secondarySymbol: string,
    attrs: any
) {
    const builderFunc = ferrous['icon' + cc(frame)];

    if(builderFunc.length === 2) {
        return builderFunc(symbol, attrs);
    } else {
        return builderFunc(symbol, secondarySymbol, attrs);
    }
}

function cc(s: string) {
    if (s === 'none') { return ''};
    return (s||'').toLowerCase().replace(/(\b|-)\w/g, function(m) {
        return m.toUpperCase().replace(/-/,'');
    });
}



// WEBPACK FOOTER //
// ./_src/ui/elements/icon.ts